import { useQuery } from "react-query"
import UserService from "~services/UserService"
import { SearchOptionShape } from "~pages/private/create-portfolio"

const useUserById = (options: string | SearchOptionShape, callback?: any) => {
  return useQuery(
    ["user", options],
    () => UserService.getUserById(options, false),
    {
      enabled: false,
    }
  )
}

export default useUserById
